import Alert from '~/components/UIKit/Alert'
import FlashBanner from '~/components/UIKit/FlashBanner'
import { useNetwork } from '~/networkProvider'
import { useAppSelector } from '~/store/hooks'

export const NetworkBanners = () => {
  const network = useNetwork()

  return (
    <>
      {!network.status && (
        <FlashBanner type="error" text="No internet connection detected. Some functionality may not work." />
      )}
      {!network.apiStatus && (
        <FlashBanner type="warning" text="The server appears to be down. Some functionality may not work." />
      )}
    </>
  )
}

export const AppAlert = () => {
  const alert = useAppSelector(state => state.alert)
  return (
    <>
      {alert.text && alert.text.length > 0 && (
        <Alert text={alert.text} type={alert.type} action={alert.action} closeable floating />
      )}
    </>
  )
}
